<script setup>
import { ref, onMounted } from 'vue';

const subscribeSuccess = ref(null);

async function setMemberStripeCustomerId() {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('sid');

    await fetch(`/Umbraco/Api/Subscription/SetMemberStripeCustomerId?stripeCheckoutSessionId=${sessionId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                subscribeSuccess.value = true;
            } else {
                subscribeSuccess.value = false;
            }
        })
        .catch(() => {
            subscribeSuccess.value = false;
        });
}

onMounted(() => {
    setMemberStripeCustomerId();
});
</script>
<template>
    <article class="text module module--white h--pad--wide">
        <div v-if="subscribeSuccess" class="text__inner">
            <h2>Tak for, at du valgte at tegne abonnement på Kulturen.NU</h2>
            <p>Glæd dig til underholdende, skarpe og sjove opdateringer på kulturlivet.</p>
            <p>Du kan altid se dit abonnement på <a href="/min-side" title="Min side.">"Min side"</a></p>
            <p>Og har du noget, du vil fortælle os - god tips eller bare brok - så skriv til os på: <a href="mailto:k@kulturen.nu">k@kulturen.nu</a></p>
        </div>
        <div v-else class="text__inner">
            <h2>Ups! Noget gik galt</h2>
            <p>Vi kunne ikke registrere dit abonnement. <a href="/tegn-abonnement" title="Tegn abonnement.">Prøv venligst igen.</a></p>
            <p>Bliver du ved med at opleve fejlen, så kontakt os på <a href="mailto:k@kulturen.nu">k@kulturen.nu</a></p>
        </div>
    </article>
</template>
